import axios from 'axios'
import { userProfileDetails, profileImages, editBasicProfileDetails } from '../../../api'
import auth from '../../modules/auth/auth'
import firebase from 'firebase/app'
import 'firebase/auth';
import gen from '../gen'
import configuration from '../../../configurations'


const state = {
  profile: {},
  maxProfileImg: -1,
  profileImages: [],
  totalCounts: {},
  selectedUploader: {},
  profileGeolocation: '',
  live_profile_pic: null, // uploaded
  hideMap: false,
  noCalls: false,
  cloudinaryWidgetOne: null
}
const getters = {
  profileGeolocation: state => state.profileGeolocation,
  profile: state => state.profile,
  maxProfileImg: state => state.maxProfileImg,
  profileImages: state => state.profileImages,
  totalCounts: state => state.totalCounts,
  selectedUploader: state => state.selectedUploader,
  live_profile_pic: state => state.live_profile_pic,
  hideMap: state => state.hideMap
}
const mutations = {
  saveUploader(state2, payload) {
    localStorage.setItem('uploader', JSON.stringify(payload))
  },
  async getUserProfileDetails(state2, payload) {
    let uid = payload.uid
    // let uploader = payload.uploader
    let x1 = await axios.get(userProfileDetails({ uid }))
    state.profile = x1.data
  },
  openCloudinaryProfileImageWidget(){
    this.cloudinaryWidgetOne.open();
  },
  async getProfileImages(state2, payload) {
    state.noCalls = false
    state.hideMap = true
    let uid = payload.uid
    let limit = payload.limit
    let startAt = payload.startAt
    let tab = payload.tab
    let orderBy = payload.orderBy
    let userGeohash = gen.state.finalUserLocation
    let isRandom = payload.isRandom
    let x1 = await axios.get(profileImages, {
      params: {
        profileUid: uid,
        limit,
        startAt,
        filter: tab,
        viewerUid: auth.state.user.uid
      }
    })
  //   if(!state.data){
  //     state.data  = await axios.get(profileImages, {
  //       params: {
  //         profileUid: uid,
  //         limit,
  //         startAt,
  //         filter: tab,
  //         viewerUid: auth.state.user.uid
  //       }
  //   })
  // }
    if (startAt === 0) {
      state.profileImages = []
    }
    if (x1.data.hits.hits.length === 0) {
      state.noCalls = true
    }
    
    for (let i in x1.data.hits.hits) {
      let photo = x1.data.hits.hits[i]._source
      let id = x1.data.hits.hits[i]._id
      let tmp = photo
      tmp.id = id
      state.profileImages.push(tmp)
    }

    // if(tab === "checkins"){
    //   for (let i in state.data.data.checkinData) {
    //     let photo = state.data.data.checkinData[i]._source
    //     let id = state.data.data.checkinData[i]._id
    //     let tmp = photo
    //     tmp.id = id
    //     state.profileImages.push(tmp)
    //   }
    // }
    // if(tab === "likes"){
    //   for (let i in state.data.data.likedDetails) {
    //     let photo = state.data.data.likedDetails[i]._source
    //     let id = state.data.data.likedDetails[i]._id
    //     let tmp = photo
    //     tmp.id = id
    //     state.profileImages.push(tmp)
    //   }
    // }
    // if(tab === "shared"){
    //   for (let i in state.data.data.submitted) {
    //     let photo = state.data.data.submitted[i]._source
    //     let id = state.data.data.submitted[i]._id
    //     let tmp = photo
    //     tmp.id = id
    //     state.profileImages.push(tmp)
    //   }
    // }
    state.hideMap = false
    setTimeout(() => {
      if (document.getElementById('scroll-hor') !== null) {
        let ele = document.getElementById(`image-${x1.data.hits.hits[0]._id}`).scrollIntoView()
      }
    }, 100)

   
    setTimeout(() => {
      gen.mutations.getLocationFinal()
    }, 10)

    state.maxProfileImg = x1.data.totalPhotos
    if (x1.data.totalCounts != undefined) {
    // state.maxProfileImg = state.profileImages.length
    // if (state.data.data.totalCounts != undefined) {
      state.totalCounts = x1.data.totalCounts
    }
  }
}
const actions = {
  saveProfileChanges(state2, payload) {
    /* return new Promise((resolve) => {
      let x1 = await axios.get(editBasicProfileDetails, {
        params: payload
      })
      resolve()
    })*/
    return new Promise(async function (resolve) {
      let x1 = await axios.get(editBasicProfileDetails, {
        params: payload
      })
      await firebase.auth().currentUser.updateProfile({
        photoURL: payload.dp
      })
      auth.state.user = firebase.auth().currentUser
      resolve('done')
    })
  },
  getProfileImageLink(state2) {
        this.cloudinaryWidgetOne = cloudinary.createUploadWidget({
          cloudName: configuration.cloudinary_cloudName,
          uploadPreset: "1920px",
          multiple: false,
          show_powered_by: false,
          imageMetadata: true,
          theme: 'minimal',
          sources: ['local']
        },(error, result) => {
          
          if (!error && result && result.event === "success") { 
            state.live_profile_pic = result.info.url
          }
          });
  }
}
export default {
  state,
  mutations,
  getters,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/user/userProfile.js